module.exports = __webpack_public_path__ + "img/racecourse-durbanville-turf-1250.3a943fb4.svg";